import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _657df2ac = () => interopDefault(import('../../../pages/_slug/index.vue' /* webpackChunkName: "" */))
const _d5a4114a = () => interopDefault(import('../../../pages/auth.vue' /* webpackChunkName: "pages/auth" */))
const _9cd58068 = () => interopDefault(import('../../../pages/avatar.vue' /* webpackChunkName: "pages/avatar" */))
const _d6ed1e1e = () => interopDefault(import('../../../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _622b41ba = () => interopDefault(import('../../../pages/event/index.vue' /* webpackChunkName: "pages/event/index" */))
const _a839d906 = () => interopDefault(import('../../../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _c177b6ca = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _1dedf2bc = () => interopDefault(import('../../../pages/subscription-center.vue' /* webpackChunkName: "pages/subscription-center" */))
const _6a104c01 = () => interopDefault(import('../../../pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _308cbda6 = () => interopDefault(import('../../../pages/event/_event/index.vue' /* webpackChunkName: "pages/event/_event/index" */))
const _67299b9c = () => interopDefault(import('../../../pages/user/_user/index.vue' /* webpackChunkName: "pages/user/_user/index" */))
const _65b252f7 = () => interopDefault(import('../../../pages/user/_user/account.vue' /* webpackChunkName: "pages/user/_user/account" */))
const _d4a5a9e8 = () => interopDefault(import('../../../pages/user/_user/edit-profile.vue' /* webpackChunkName: "pages/user/_user/edit-profile" */))
const _6c79bab2 = () => interopDefault(import('../../../pages/user/_user/notifications.vue' /* webpackChunkName: "pages/user/_user/notifications" */))
const _0fb9861d = () => interopDefault(import('../../../pages/user/_user/posts.vue' /* webpackChunkName: "pages/user/_user/posts" */))
const _e8a4725c = () => interopDefault(import('../../../pages/user/_user/privacy.vue' /* webpackChunkName: "pages/user/_user/privacy" */))
const _58293e36 = () => interopDefault(import('../../../pages/user/_user/reading-list.vue' /* webpackChunkName: "pages/user/_user/reading-list" */))
const _2a106f0b = () => interopDefault(import('../../../pages/_slug/_topic/index.vue' /* webpackChunkName: "pages/_slug/_topic/index" */))
const _68253d4a = () => interopDefault(import('../../../pages/_slug/_topic/_subtopic/index.vue' /* webpackChunkName: "pages/_slug/_topic/_subtopic/index" */))
const _187a69ba = () => interopDefault(import('../../../pages/_slug/_topic/_subtopic/_articleSlug.vue' /* webpackChunkName: "pages/_slug/_topic/_subtopic/_articleSlug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'is-active-link',
  linkExactActiveClass: 'is-exact-active-link',
  scrollBehavior,

  routes: [{
    path: "/ar",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___ar"
  }, {
    path: "/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth"
  }, {
    path: "/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar"
  }, {
    path: "/cs",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___cs"
  }, {
    path: "/da",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___da"
  }, {
    path: "/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard"
  }, {
    path: "/de",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___de"
  }, {
    path: "/el_gr",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___el_gr"
  }, {
    path: "/en",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___en"
  }, {
    path: "/en_au",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___en_au"
  }, {
    path: "/en_gb",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___en_gb"
  }, {
    path: "/en_in",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___en_in"
  }, {
    path: "/en_us",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___en_us"
  }, {
    path: "/es_es",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___es_es"
  }, {
    path: "/event",
    component: _622b41ba,
    meta: {},
    name: "event"
  }, {
    path: "/fr",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___fr"
  }, {
    path: "/id",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___id"
  }, {
    path: "/it_it",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___it_it"
  }, {
    path: "/logout",
    component: _a839d906,
    meta: {},
    name: "logout"
  }, {
    path: "/nl",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___nl"
  }, {
    path: "/no",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___no"
  }, {
    path: "/pl",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___pl"
  }, {
    path: "/pt_br",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___pt_br"
  }, {
    path: "/search",
    component: _c177b6ca,
    meta: {},
    name: "search"
  }, {
    path: "/sk",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___sk"
  }, {
    path: "/sl",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___sl"
  }, {
    path: "/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center"
  }, {
    path: "/sv",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index___sv"
  }, {
    path: "/user",
    component: _6a104c01,
    meta: {},
    name: "user"
  }, {
    path: "/ar/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___ar"
  }, {
    path: "/ar/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___ar"
  }, {
    path: "/ar/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___ar"
  }, {
    path: "/ar/event",
    component: _622b41ba,
    meta: {},
    name: "event___ar"
  }, {
    path: "/ar/logout",
    component: _a839d906,
    meta: {},
    name: "logout___ar"
  }, {
    path: "/ar/search",
    component: _c177b6ca,
    meta: {},
    name: "search___ar"
  }, {
    path: "/ar/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___ar"
  }, {
    path: "/ar/user",
    component: _6a104c01,
    meta: {},
    name: "user___ar"
  }, {
    path: "/cs/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___cs"
  }, {
    path: "/cs/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___cs"
  }, {
    path: "/cs/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___cs"
  }, {
    path: "/cs/event",
    component: _622b41ba,
    meta: {},
    name: "event___cs"
  }, {
    path: "/cs/logout",
    component: _a839d906,
    meta: {},
    name: "logout___cs"
  }, {
    path: "/cs/search",
    component: _c177b6ca,
    meta: {},
    name: "search___cs"
  }, {
    path: "/cs/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___cs"
  }, {
    path: "/cs/user",
    component: _6a104c01,
    meta: {},
    name: "user___cs"
  }, {
    path: "/da/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___da"
  }, {
    path: "/da/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___da"
  }, {
    path: "/da/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___da"
  }, {
    path: "/da/event",
    component: _622b41ba,
    meta: {},
    name: "event___da"
  }, {
    path: "/da/logout",
    component: _a839d906,
    meta: {},
    name: "logout___da"
  }, {
    path: "/da/search",
    component: _c177b6ca,
    meta: {},
    name: "search___da"
  }, {
    path: "/da/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___da"
  }, {
    path: "/da/user",
    component: _6a104c01,
    meta: {},
    name: "user___da"
  }, {
    path: "/de/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___de"
  }, {
    path: "/de/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___de"
  }, {
    path: "/de/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___de"
  }, {
    path: "/de/event",
    component: _622b41ba,
    meta: {},
    name: "event___de"
  }, {
    path: "/de/logout",
    component: _a839d906,
    meta: {},
    name: "logout___de"
  }, {
    path: "/de/search",
    component: _c177b6ca,
    meta: {},
    name: "search___de"
  }, {
    path: "/de/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___de"
  }, {
    path: "/de/user",
    component: _6a104c01,
    meta: {},
    name: "user___de"
  }, {
    path: "/el_gr/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___el_gr"
  }, {
    path: "/el_gr/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___el_gr"
  }, {
    path: "/el_gr/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___el_gr"
  }, {
    path: "/el_gr/event",
    component: _622b41ba,
    meta: {},
    name: "event___el_gr"
  }, {
    path: "/el_gr/logout",
    component: _a839d906,
    meta: {},
    name: "logout___el_gr"
  }, {
    path: "/el_gr/search",
    component: _c177b6ca,
    meta: {},
    name: "search___el_gr"
  }, {
    path: "/el_gr/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___el_gr"
  }, {
    path: "/el_gr/user",
    component: _6a104c01,
    meta: {},
    name: "user___el_gr"
  }, {
    path: "/en_au/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___en_au"
  }, {
    path: "/en_au/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___en_au"
  }, {
    path: "/en_au/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___en_au"
  }, {
    path: "/en_au/event",
    component: _622b41ba,
    meta: {},
    name: "event___en_au"
  }, {
    path: "/en_au/logout",
    component: _a839d906,
    meta: {},
    name: "logout___en_au"
  }, {
    path: "/en_au/search",
    component: _c177b6ca,
    meta: {},
    name: "search___en_au"
  }, {
    path: "/en_au/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___en_au"
  }, {
    path: "/en_au/user",
    component: _6a104c01,
    meta: {},
    name: "user___en_au"
  }, {
    path: "/en_gb/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___en_gb"
  }, {
    path: "/en_gb/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___en_gb"
  }, {
    path: "/en_gb/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___en_gb"
  }, {
    path: "/en_gb/event",
    component: _622b41ba,
    meta: {},
    name: "event___en_gb"
  }, {
    path: "/en_gb/logout",
    component: _a839d906,
    meta: {},
    name: "logout___en_gb"
  }, {
    path: "/en_gb/search",
    component: _c177b6ca,
    meta: {},
    name: "search___en_gb"
  }, {
    path: "/en_gb/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___en_gb"
  }, {
    path: "/en_gb/user",
    component: _6a104c01,
    meta: {},
    name: "user___en_gb"
  }, {
    path: "/en_in/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___en_in"
  }, {
    path: "/en_in/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___en_in"
  }, {
    path: "/en_in/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___en_in"
  }, {
    path: "/en_in/event",
    component: _622b41ba,
    meta: {},
    name: "event___en_in"
  }, {
    path: "/en_in/logout",
    component: _a839d906,
    meta: {},
    name: "logout___en_in"
  }, {
    path: "/en_in/search",
    component: _c177b6ca,
    meta: {},
    name: "search___en_in"
  }, {
    path: "/en_in/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___en_in"
  }, {
    path: "/en_in/user",
    component: _6a104c01,
    meta: {},
    name: "user___en_in"
  }, {
    path: "/en_us/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___en_us"
  }, {
    path: "/en_us/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___en_us"
  }, {
    path: "/en_us/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___en_us"
  }, {
    path: "/en_us/event",
    component: _622b41ba,
    meta: {},
    name: "event___en_us"
  }, {
    path: "/en_us/logout",
    component: _a839d906,
    meta: {},
    name: "logout___en_us"
  }, {
    path: "/en_us/search",
    component: _c177b6ca,
    meta: {},
    name: "search___en_us"
  }, {
    path: "/en_us/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___en_us"
  }, {
    path: "/en_us/user",
    component: _6a104c01,
    meta: {},
    name: "user___en_us"
  }, {
    path: "/en/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___en"
  }, {
    path: "/en/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___en"
  }, {
    path: "/en/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___en"
  }, {
    path: "/en/event",
    component: _622b41ba,
    meta: {},
    name: "event___en"
  }, {
    path: "/en/logout",
    component: _a839d906,
    meta: {},
    name: "logout___en"
  }, {
    path: "/en/search",
    component: _c177b6ca,
    meta: {},
    name: "search___en"
  }, {
    path: "/en/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___en"
  }, {
    path: "/en/user",
    component: _6a104c01,
    meta: {},
    name: "user___en"
  }, {
    path: "/es_es/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___es_es"
  }, {
    path: "/es_es/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___es_es"
  }, {
    path: "/es_es/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___es_es"
  }, {
    path: "/es_es/event",
    component: _622b41ba,
    meta: {},
    name: "event___es_es"
  }, {
    path: "/es_es/logout",
    component: _a839d906,
    meta: {},
    name: "logout___es_es"
  }, {
    path: "/es_es/search",
    component: _c177b6ca,
    meta: {},
    name: "search___es_es"
  }, {
    path: "/es_es/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___es_es"
  }, {
    path: "/es_es/user",
    component: _6a104c01,
    meta: {},
    name: "user___es_es"
  }, {
    path: "/fr/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___fr"
  }, {
    path: "/fr/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___fr"
  }, {
    path: "/fr/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___fr"
  }, {
    path: "/fr/event",
    component: _622b41ba,
    meta: {},
    name: "event___fr"
  }, {
    path: "/fr/logout",
    component: _a839d906,
    meta: {},
    name: "logout___fr"
  }, {
    path: "/fr/search",
    component: _c177b6ca,
    meta: {},
    name: "search___fr"
  }, {
    path: "/fr/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___fr"
  }, {
    path: "/fr/user",
    component: _6a104c01,
    meta: {},
    name: "user___fr"
  }, {
    path: "/id/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___id"
  }, {
    path: "/id/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___id"
  }, {
    path: "/id/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___id"
  }, {
    path: "/id/event",
    component: _622b41ba,
    meta: {},
    name: "event___id"
  }, {
    path: "/id/logout",
    component: _a839d906,
    meta: {},
    name: "logout___id"
  }, {
    path: "/id/search",
    component: _c177b6ca,
    meta: {},
    name: "search___id"
  }, {
    path: "/id/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___id"
  }, {
    path: "/id/user",
    component: _6a104c01,
    meta: {},
    name: "user___id"
  }, {
    path: "/it_it/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___it_it"
  }, {
    path: "/it_it/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___it_it"
  }, {
    path: "/it_it/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___it_it"
  }, {
    path: "/it_it/event",
    component: _622b41ba,
    meta: {},
    name: "event___it_it"
  }, {
    path: "/it_it/logout",
    component: _a839d906,
    meta: {},
    name: "logout___it_it"
  }, {
    path: "/it_it/search",
    component: _c177b6ca,
    meta: {},
    name: "search___it_it"
  }, {
    path: "/it_it/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___it_it"
  }, {
    path: "/it_it/user",
    component: _6a104c01,
    meta: {},
    name: "user___it_it"
  }, {
    path: "/nl/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___nl"
  }, {
    path: "/nl/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___nl"
  }, {
    path: "/nl/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___nl"
  }, {
    path: "/nl/event",
    component: _622b41ba,
    meta: {},
    name: "event___nl"
  }, {
    path: "/nl/logout",
    component: _a839d906,
    meta: {},
    name: "logout___nl"
  }, {
    path: "/nl/search",
    component: _c177b6ca,
    meta: {},
    name: "search___nl"
  }, {
    path: "/nl/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___nl"
  }, {
    path: "/nl/user",
    component: _6a104c01,
    meta: {},
    name: "user___nl"
  }, {
    path: "/no/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___no"
  }, {
    path: "/no/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___no"
  }, {
    path: "/no/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___no"
  }, {
    path: "/no/event",
    component: _622b41ba,
    meta: {},
    name: "event___no"
  }, {
    path: "/no/logout",
    component: _a839d906,
    meta: {},
    name: "logout___no"
  }, {
    path: "/no/search",
    component: _c177b6ca,
    meta: {},
    name: "search___no"
  }, {
    path: "/no/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___no"
  }, {
    path: "/no/user",
    component: _6a104c01,
    meta: {},
    name: "user___no"
  }, {
    path: "/pl/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___pl"
  }, {
    path: "/pl/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___pl"
  }, {
    path: "/pl/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___pl"
  }, {
    path: "/pl/event",
    component: _622b41ba,
    meta: {},
    name: "event___pl"
  }, {
    path: "/pl/logout",
    component: _a839d906,
    meta: {},
    name: "logout___pl"
  }, {
    path: "/pl/search",
    component: _c177b6ca,
    meta: {},
    name: "search___pl"
  }, {
    path: "/pl/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___pl"
  }, {
    path: "/pl/user",
    component: _6a104c01,
    meta: {},
    name: "user___pl"
  }, {
    path: "/pt_br/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___pt_br"
  }, {
    path: "/pt_br/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___pt_br"
  }, {
    path: "/pt_br/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___pt_br"
  }, {
    path: "/pt_br/event",
    component: _622b41ba,
    meta: {},
    name: "event___pt_br"
  }, {
    path: "/pt_br/logout",
    component: _a839d906,
    meta: {},
    name: "logout___pt_br"
  }, {
    path: "/pt_br/search",
    component: _c177b6ca,
    meta: {},
    name: "search___pt_br"
  }, {
    path: "/pt_br/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___pt_br"
  }, {
    path: "/pt_br/user",
    component: _6a104c01,
    meta: {},
    name: "user___pt_br"
  }, {
    path: "/sk/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___sk"
  }, {
    path: "/sk/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___sk"
  }, {
    path: "/sk/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___sk"
  }, {
    path: "/sk/event",
    component: _622b41ba,
    meta: {},
    name: "event___sk"
  }, {
    path: "/sk/logout",
    component: _a839d906,
    meta: {},
    name: "logout___sk"
  }, {
    path: "/sk/search",
    component: _c177b6ca,
    meta: {},
    name: "search___sk"
  }, {
    path: "/sk/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___sk"
  }, {
    path: "/sk/user",
    component: _6a104c01,
    meta: {},
    name: "user___sk"
  }, {
    path: "/sl/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___sl"
  }, {
    path: "/sl/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___sl"
  }, {
    path: "/sl/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___sl"
  }, {
    path: "/sl/event",
    component: _622b41ba,
    meta: {},
    name: "event___sl"
  }, {
    path: "/sl/logout",
    component: _a839d906,
    meta: {},
    name: "logout___sl"
  }, {
    path: "/sl/search",
    component: _c177b6ca,
    meta: {},
    name: "search___sl"
  }, {
    path: "/sl/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___sl"
  }, {
    path: "/sl/user",
    component: _6a104c01,
    meta: {},
    name: "user___sl"
  }, {
    path: "/sv/auth",
    component: _d5a4114a,
    meta: {},
    name: "auth___sv"
  }, {
    path: "/sv/avatar",
    component: _9cd58068,
    meta: {},
    name: "avatar___sv"
  }, {
    path: "/sv/dashboard",
    component: _d6ed1e1e,
    meta: {"name":"Dashboard","layout":"userSpace","middleware":"auth","headerBack":false,"icon":"grid"},
    name: "dashboard___sv"
  }, {
    path: "/sv/event",
    component: _622b41ba,
    meta: {},
    name: "event___sv"
  }, {
    path: "/sv/logout",
    component: _a839d906,
    meta: {},
    name: "logout___sv"
  }, {
    path: "/sv/search",
    component: _c177b6ca,
    meta: {},
    name: "search___sv"
  }, {
    path: "/sv/subscription-center",
    component: _1dedf2bc,
    meta: {},
    name: "subscription-center___sv"
  }, {
    path: "/sv/user",
    component: _6a104c01,
    meta: {},
    name: "user___sv"
  }, {
    path: "/ar/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___ar"
  }, {
    path: "/ar/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___ar"
  }, {
    path: "/cs/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___cs"
  }, {
    path: "/cs/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___cs"
  }, {
    path: "/da/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___da"
  }, {
    path: "/da/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___da"
  }, {
    path: "/de/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___de"
  }, {
    path: "/de/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___de"
  }, {
    path: "/el_gr/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___el_gr"
  }, {
    path: "/el_gr/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___el_gr"
  }, {
    path: "/en_au/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___en_au"
  }, {
    path: "/en_au/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___en_au"
  }, {
    path: "/en_gb/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___en_gb"
  }, {
    path: "/en_gb/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___en_gb"
  }, {
    path: "/en_in/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___en_in"
  }, {
    path: "/en_in/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___en_in"
  }, {
    path: "/en_us/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___en_us"
  }, {
    path: "/en_us/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___en_us"
  }, {
    path: "/en/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___en"
  }, {
    path: "/en/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___en"
  }, {
    path: "/es_es/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___es_es"
  }, {
    path: "/es_es/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___es_es"
  }, {
    path: "/fr/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___fr"
  }, {
    path: "/fr/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___fr"
  }, {
    path: "/id/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___id"
  }, {
    path: "/id/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___id"
  }, {
    path: "/it_it/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___it_it"
  }, {
    path: "/it_it/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___it_it"
  }, {
    path: "/nl/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___nl"
  }, {
    path: "/nl/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___nl"
  }, {
    path: "/no/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___no"
  }, {
    path: "/no/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___no"
  }, {
    path: "/pl/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___pl"
  }, {
    path: "/pl/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___pl"
  }, {
    path: "/pt_br/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___pt_br"
  }, {
    path: "/pt_br/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___pt_br"
  }, {
    path: "/sk/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___sk"
  }, {
    path: "/sk/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___sk"
  }, {
    path: "/sl/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___sl"
  }, {
    path: "/sl/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___sl"
  }, {
    path: "/sv/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event___sv"
  }, {
    path: "/sv/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user___sv"
  }, {
    path: "/ar/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___ar"
  }, {
    path: "/ar/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___ar"
  }, {
    path: "/ar/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___ar"
  }, {
    path: "/ar/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___ar"
  }, {
    path: "/ar/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___ar"
  }, {
    path: "/ar/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___ar"
  }, {
    path: "/cs/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___cs"
  }, {
    path: "/cs/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___cs"
  }, {
    path: "/cs/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___cs"
  }, {
    path: "/cs/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___cs"
  }, {
    path: "/cs/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___cs"
  }, {
    path: "/cs/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___cs"
  }, {
    path: "/da/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___da"
  }, {
    path: "/da/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___da"
  }, {
    path: "/da/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___da"
  }, {
    path: "/da/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___da"
  }, {
    path: "/da/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___da"
  }, {
    path: "/da/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___da"
  }, {
    path: "/de/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___de"
  }, {
    path: "/de/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___de"
  }, {
    path: "/de/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___de"
  }, {
    path: "/de/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___de"
  }, {
    path: "/de/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___de"
  }, {
    path: "/de/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___de"
  }, {
    path: "/el_gr/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___el_gr"
  }, {
    path: "/el_gr/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___el_gr"
  }, {
    path: "/el_gr/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___el_gr"
  }, {
    path: "/el_gr/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___el_gr"
  }, {
    path: "/el_gr/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___el_gr"
  }, {
    path: "/el_gr/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___el_gr"
  }, {
    path: "/en_au/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___en_au"
  }, {
    path: "/en_au/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___en_au"
  }, {
    path: "/en_au/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___en_au"
  }, {
    path: "/en_au/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___en_au"
  }, {
    path: "/en_au/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___en_au"
  }, {
    path: "/en_au/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___en_au"
  }, {
    path: "/en_gb/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___en_gb"
  }, {
    path: "/en_gb/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___en_gb"
  }, {
    path: "/en_gb/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___en_gb"
  }, {
    path: "/en_gb/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___en_gb"
  }, {
    path: "/en_gb/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___en_gb"
  }, {
    path: "/en_gb/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___en_gb"
  }, {
    path: "/en_in/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___en_in"
  }, {
    path: "/en_in/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___en_in"
  }, {
    path: "/en_in/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___en_in"
  }, {
    path: "/en_in/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___en_in"
  }, {
    path: "/en_in/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___en_in"
  }, {
    path: "/en_in/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___en_in"
  }, {
    path: "/en_us/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___en_us"
  }, {
    path: "/en_us/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___en_us"
  }, {
    path: "/en_us/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___en_us"
  }, {
    path: "/en_us/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___en_us"
  }, {
    path: "/en_us/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___en_us"
  }, {
    path: "/en_us/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___en_us"
  }, {
    path: "/en/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___en"
  }, {
    path: "/en/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___en"
  }, {
    path: "/en/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___en"
  }, {
    path: "/en/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___en"
  }, {
    path: "/en/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___en"
  }, {
    path: "/en/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___en"
  }, {
    path: "/es_es/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___es_es"
  }, {
    path: "/es_es/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___es_es"
  }, {
    path: "/es_es/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___es_es"
  }, {
    path: "/es_es/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___es_es"
  }, {
    path: "/es_es/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___es_es"
  }, {
    path: "/es_es/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___es_es"
  }, {
    path: "/fr/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___fr"
  }, {
    path: "/fr/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___fr"
  }, {
    path: "/fr/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___fr"
  }, {
    path: "/fr/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___fr"
  }, {
    path: "/fr/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___fr"
  }, {
    path: "/fr/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___fr"
  }, {
    path: "/id/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___id"
  }, {
    path: "/id/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___id"
  }, {
    path: "/id/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___id"
  }, {
    path: "/id/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___id"
  }, {
    path: "/id/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___id"
  }, {
    path: "/id/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___id"
  }, {
    path: "/it_it/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___it_it"
  }, {
    path: "/it_it/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___it_it"
  }, {
    path: "/it_it/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___it_it"
  }, {
    path: "/it_it/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___it_it"
  }, {
    path: "/it_it/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___it_it"
  }, {
    path: "/it_it/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___it_it"
  }, {
    path: "/nl/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___nl"
  }, {
    path: "/nl/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___nl"
  }, {
    path: "/nl/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___nl"
  }, {
    path: "/nl/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___nl"
  }, {
    path: "/nl/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___nl"
  }, {
    path: "/nl/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___nl"
  }, {
    path: "/no/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___no"
  }, {
    path: "/no/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___no"
  }, {
    path: "/no/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___no"
  }, {
    path: "/no/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___no"
  }, {
    path: "/no/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___no"
  }, {
    path: "/no/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___no"
  }, {
    path: "/pl/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___pl"
  }, {
    path: "/pl/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___pl"
  }, {
    path: "/pl/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___pl"
  }, {
    path: "/pl/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___pl"
  }, {
    path: "/pl/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___pl"
  }, {
    path: "/pl/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___pl"
  }, {
    path: "/pt_br/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___pt_br"
  }, {
    path: "/pt_br/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___pt_br"
  }, {
    path: "/pt_br/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___pt_br"
  }, {
    path: "/pt_br/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___pt_br"
  }, {
    path: "/pt_br/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___pt_br"
  }, {
    path: "/pt_br/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___pt_br"
  }, {
    path: "/sk/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___sk"
  }, {
    path: "/sk/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___sk"
  }, {
    path: "/sk/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___sk"
  }, {
    path: "/sk/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___sk"
  }, {
    path: "/sk/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___sk"
  }, {
    path: "/sk/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___sk"
  }, {
    path: "/sl/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___sl"
  }, {
    path: "/sl/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___sl"
  }, {
    path: "/sl/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___sl"
  }, {
    path: "/sl/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___sl"
  }, {
    path: "/sl/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___sl"
  }, {
    path: "/sl/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___sl"
  }, {
    path: "/sv/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account___sv"
  }, {
    path: "/sv/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile___sv"
  }, {
    path: "/sv/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications___sv"
  }, {
    path: "/sv/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts___sv"
  }, {
    path: "/sv/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy___sv"
  }, {
    path: "/sv/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list___sv"
  }, {
    path: "/ar/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___ar"
  }, {
    path: "/cs/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___cs"
  }, {
    path: "/da/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___da"
  }, {
    path: "/de/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___de"
  }, {
    path: "/el_gr/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___el_gr"
  }, {
    path: "/en_au/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___en_au"
  }, {
    path: "/en_gb/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___en_gb"
  }, {
    path: "/en_in/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___en_in"
  }, {
    path: "/en_us/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___en_us"
  }, {
    path: "/en/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___en"
  }, {
    path: "/es_es/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___es_es"
  }, {
    path: "/event/:event",
    component: _308cbda6,
    meta: {"name":"EventData","mentorOnly":true,"headerBack":{"backUrl":"/events","showEditButton":true},"group":"eventData","icon":"event"},
    name: "event-event"
  }, {
    path: "/fr/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___fr"
  }, {
    path: "/id/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___id"
  }, {
    path: "/it_it/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___it_it"
  }, {
    path: "/nl/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___nl"
  }, {
    path: "/no/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___no"
  }, {
    path: "/pl/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___pl"
  }, {
    path: "/pt_br/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___pt_br"
  }, {
    path: "/sk/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___sk"
  }, {
    path: "/sl/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___sl"
  }, {
    path: "/sv/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug___sv"
  }, {
    path: "/user/:user",
    component: _67299b9c,
    meta: {"name":"UserProfile","mentorOnly":true,"headerBack":{"backUrl":"/dashboard","showEditButton":true},"group":"userProfile","icon":"user"},
    name: "user-user"
  }, {
    path: "/user/:user/account",
    component: _65b252f7,
    meta: {"name":"UserAccountSettings","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"settings"},
    name: "user-user-account"
  }, {
    path: "/user/:user/edit-profile",
    component: _d4a5a9e8,
    meta: {"name":"UserEditProfile","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings","icon":"edit"},
    name: "user-user-edit-profile"
  }, {
    path: "/user/:user/notifications",
    component: _6c79bab2,
    meta: {"name":"UserNotifications","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"bell"},
    name: "user-user-notifications"
  }, {
    path: "/user/:user/posts",
    component: _0fb9861d,
    meta: {"name":"UserPosts","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"pen"},
    name: "user-user-posts"
  }, {
    path: "/user/:user/privacy",
    component: _e8a4725c,
    meta: {"name":"UserPrivacy","layout":"userSpace","middleware":"auth","headerBack":{"backUrl":"/dashboard"},"group":"userSettings-disabled","icon":"lock"},
    name: "user-user-privacy"
  }, {
    path: "/user/:user/reading-list",
    component: _58293e36,
    meta: {"name":"UserReadingList","layout":"user","middleware":"auth","group":"userProfile-disabled","icon":"bookmark"},
    name: "user-user-reading-list"
  }, {
    path: "/ar/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___ar"
  }, {
    path: "/cs/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___cs"
  }, {
    path: "/da/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___da"
  }, {
    path: "/de/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___de"
  }, {
    path: "/el_gr/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___el_gr"
  }, {
    path: "/en_au/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___en_au"
  }, {
    path: "/en_gb/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___en_gb"
  }, {
    path: "/en_in/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___en_in"
  }, {
    path: "/en_us/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___en_us"
  }, {
    path: "/en/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___en"
  }, {
    path: "/es_es/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___es_es"
  }, {
    path: "/fr/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___fr"
  }, {
    path: "/id/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___id"
  }, {
    path: "/it_it/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___it_it"
  }, {
    path: "/nl/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___nl"
  }, {
    path: "/no/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___no"
  }, {
    path: "/pl/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___pl"
  }, {
    path: "/pt_br/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___pt_br"
  }, {
    path: "/sk/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___sk"
  }, {
    path: "/sl/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___sl"
  }, {
    path: "/sv/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic___sv"
  }, {
    path: "/ar/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___ar"
  }, {
    path: "/cs/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___cs"
  }, {
    path: "/da/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___da"
  }, {
    path: "/de/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___de"
  }, {
    path: "/el_gr/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___el_gr"
  }, {
    path: "/en_au/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___en_au"
  }, {
    path: "/en_gb/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___en_gb"
  }, {
    path: "/en_in/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___en_in"
  }, {
    path: "/en_us/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___en_us"
  }, {
    path: "/en/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___en"
  }, {
    path: "/es_es/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___es_es"
  }, {
    path: "/fr/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___fr"
  }, {
    path: "/id/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___id"
  }, {
    path: "/it_it/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___it_it"
  }, {
    path: "/nl/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___nl"
  }, {
    path: "/no/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___no"
  }, {
    path: "/pl/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___pl"
  }, {
    path: "/pt_br/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___pt_br"
  }, {
    path: "/sk/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___sk"
  }, {
    path: "/sl/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___sl"
  }, {
    path: "/sv/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic___sv"
  }, {
    path: "/ar/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___ar"
  }, {
    path: "/cs/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___cs"
  }, {
    path: "/da/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___da"
  }, {
    path: "/de/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___de"
  }, {
    path: "/el_gr/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___el_gr"
  }, {
    path: "/en_au/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___en_au"
  }, {
    path: "/en_gb/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___en_gb"
  }, {
    path: "/en_in/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___en_in"
  }, {
    path: "/en_us/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___en_us"
  }, {
    path: "/en/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___en"
  }, {
    path: "/es_es/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___es_es"
  }, {
    path: "/fr/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___fr"
  }, {
    path: "/id/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___id"
  }, {
    path: "/it_it/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___it_it"
  }, {
    path: "/nl/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___nl"
  }, {
    path: "/no/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___no"
  }, {
    path: "/pl/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___pl"
  }, {
    path: "/pt_br/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___pt_br"
  }, {
    path: "/sk/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___sk"
  }, {
    path: "/sl/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___sl"
  }, {
    path: "/sv/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug___sv"
  }, {
    path: "/",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "index"
  }, {
    path: "/:slug",
    component: _657df2ac,
    meta: {"name":"PageDepth1"},
    name: "slug"
  }, {
    path: "/:slug?/:topic",
    component: _2a106f0b,
    meta: {"name":"PageDepth2"},
    name: "slug-topic"
  }, {
    path: "/:slug?/:topic/:subtopic",
    component: _68253d4a,
    meta: {"name":"PageDepth3"},
    name: "slug-topic-subtopic"
  }, {
    path: "/:slug?/:topic/:subtopic/:articleSlug",
    component: _187a69ba,
    meta: {"name":"PageDepth4"},
    name: "slug-topic-subtopic-articleSlug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
